import { api } from './api';
import type { ApiResponse } from '@/types/api';

export interface WhatsAppConfig {
  phone: string;
  whatsappEnabled: boolean;
  zapiConfigured: boolean;
  zapiInstanceId?: string;
}

export interface WhatsAppTestResult {
  ok: boolean;
  status?: string;
  instanceId?: string;
  error?: string;
}

export const integrationService = {
  getWhatsAppConfig: async (): Promise<WhatsAppConfig> => {
    const res = await api.get<ApiResponse<WhatsAppConfig>>('/integrations/whatsapp/config');
    return res.data.data;
  },

  updateWhatsAppConfig: async (data: Partial<Pick<WhatsAppConfig, 'phone' | 'whatsappEnabled'>>): Promise<WhatsAppConfig> => {
    const res = await api.put<ApiResponse<WhatsAppConfig>>('/integrations/whatsapp/config', data);
    return res.data.data;
  },

  testWhatsAppConnection: async (): Promise<WhatsAppTestResult> => {
    const res = await api.post<ApiResponse<WhatsAppTestResult>>('/integrations/whatsapp/test');
    return res.data.data;
  },
};
